import * as Mutation from './mutation-types'
import axios from 'axios'
import {urlApi} from '../../config/url-api'
import store from "./index";

export default {
    createEvent ({ commit }, event) {
        return commit(Mutation.CREATE_EVENT, event)
    },
    updateEvent ({ commit }, updatedEvent) {
        return commit(Mutation.UPDATE_EVENT, updatedEvent)
    },
    deleteEvent ({ commit }, eventId) {
        return commit(Mutation.DELETE_EVENT, eventId)
    },
    setweekendsVisible ({ commit }, enabled) {
        return commit(Mutation.SET_WEEKENDS_ENABLED, enabled)
    },
    setScrollHidden({commit}, enabled){
        return commit(Mutation.SCROLL_BEHAVIOR, enabled)
    },
    // eslint-disable-next-line no-unused-vars
    authRequest({commit, dispatch}, user) {
        store.commit("TOGGLE_LOADING", true)
        return new Promise((resolve, reject) => { // The Promise used for router redirect in login
            commit(Mutation.AUTH_REQUEST)
            axios({url: urlApi.auth.login, data: user, method: 'POST' })
                .then(resp => {
                    store.commit("TOGGLE_LOADING", false)
                    if (resp.data.success){
                        const token = resp.data.token
                        const profile = resp.data
                        const routes = resp.data.routes
                        const menus = resp.data.menus
                        // localStorage.setItem('user-token', token) // store the token in localstorage
                        // localStorage.setItem('user-profile', JSON.stringify(profile))
                        // localStorage.setItem('photo_profile',  profile.data.attributes.emp_photo)
                        commit('SET_TOKEN', token)
                        commit(Mutation.UPDATE_PHOTO_PROFILE, profile.data.attributes.emp_photo)
                        commit(Mutation.AUTH_SUCCESS, profile)
                        // commit(Mutation.ROUTES, routes)
                        commit(Mutation.MENUS, menus)

                        resolve(resp)
                    }else{
                        let err = new TypeError("Login failed")
                        err.response.data.message = resp.message
                        reject(err)
                    }

                })
                .catch(err => {
                    commit("TOGGLE_LOADING", false)
                    commit(Mutation.AUTH_ERROR, err)
                    localStorage.removeItem('user-token') // if the request fails, remove any possible user token if possible
                    reject(err)
                })
        })
    },
    [Mutation.AUTH_LOGOUT]:({commit, dispatch}) =>{
        return new Promise((resolve, reject) => {
            commit(Mutation.AUTH_LOGOUT)
            localStorage.removeItem('user-token') // clear your user's token from localstorage
            localStorage.removeItem('user-profile') // clear your user's token from localstorage
            localStorage.removeItem('isMultiple') // clear your user's token from localstorage
            localStorage.removeItem('user-id') // clear your user's token from localstorage
            localStorage.removeItem('emp-id') // clear your user's token from localstorage
            localStorage.removeItem('company-settings') // clear your user's token from localstorage
            resolve()
        })
    },
    updatePhotoProfile ({ commit }, photo_profile) {
        return commit(Mutation.UPDATE_PHOTO_PROFILE, photo_profile)
    },
}